
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nosotros",
      function () {
        return require("private-next-pages/nosotros/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nosotros"])
      });
    }
  